"use client"

import { EyeClosed } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `EyeClosedIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const EyeClosedIcon = component(Icon)({ as: EyeClosed })
